import React from 'react';
import { Link } from 'react-router-dom';
import NotificationContactSupport from './notification-contact-support';
import { notificationMessages, NotificationResponseStatus, NotificationType, PolicyNotificationDto } from 'src/dtos/notification.dto';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { Popover } from 'antd';
import PolicySuccessIcon from '@svg/green-checkmark-circle.svg?react';
import FailureIcon from '@svg/x-circle-red.svg?react';

interface PolicyNotificationProps {
    notification: PolicyNotificationDto;
    isFailure: boolean;
}

const ConnectionsPopover: React.FC<{ connections: { connection: string; status: 'success' | 'failure' | null; }[] }> = ({ connections }) => (
    <Popover showArrow={true}
             placement={'bottom'}
             overlayClassName={'connections-popover'}
             content={connections.map(item => <div className={'info-row'} key={item.connection}>{item.connection}</div>)}>
        <span className={'connections-count'}>{connections.length} connections</span>
    </Popover>
);

const PolicyNotification: React.FC<PolicyNotificationProps> = observer(({ notification, isFailure }) => {

    const { fwVersionStore } = useStores();
    const notificationPolicy = notificationMessages[NotificationType.POLICY_UPDATE];
    const { message } = notificationPolicy[notification.status];

    const generateNotificationMessage = () => {
        if (notification.pushPolicyTargetConnectionNameAndStatusList) {
            const successfulConnections =
                notification.pushPolicyTargetConnectionNameAndStatusList.filter(item => item.status === 'success');

            const failedConnections =
                notification.pushPolicyTargetConnectionNameAndStatusList.filter(item => item.status === 'failure');

            switch (notification.status) {
                case NotificationResponseStatus.NOTIFICATION_PENDING:
                    return <>has been copied to <ConnectionsPopover connections={notification.pushPolicyTargetConnectionNameAndStatusList} /> and is
                        now being processed. You'll be notified once applied.</>;
                case NotificationResponseStatus.NOTIFICATION_SUCCESS:
                    return <>was successfully applied in <ConnectionsPopover connections={notification.pushPolicyTargetConnectionNameAndStatusList} />.</>;
                case NotificationResponseStatus.NOTIFICATION_ERROR:
                    return <>has failed in <ConnectionsPopover connections={notification.pushPolicyTargetConnectionNameAndStatusList} />.</>;
                case NotificationResponseStatus.NOTIFICATION_PARTIAL_SUCCESS:
                    return <>
                        <div><FailureIcon /> Failed in <ConnectionsPopover connections={failedConnections} />.</div>
                        <div><PolicySuccessIcon /> Successfully pushed and applied in <ConnectionsPopover connections={successfulConnections} />.</div>
                    </>;
            }
        }

        return message;
    };

    return <>
        <div className="details">
            {!notification.isVersionDeleted ?
                <Link to={`/${notification.customerId}/${notification.serviceId}/protection/version/${notification.policyExternalId}/${fwVersionStore.versionProtectionPath}`}
                      className="policy-name">
                Policy V{notification.policyVersionNumber}
            </Link> : <span className="policy-name">Policy V{notification.policyVersionNumber} (deleted)</span>}
            <span>{generateNotificationMessage()}</span>
            {notification.description && <div>{notification.description}</div>}
            {isFailure && <NotificationContactSupport/>}
        </div>
        {notification.userName && <div className={'internal-user-symbol'}>
            {!notification.userName.includes('@') && <CustomIcon type={IconType.APPLY_ATT} size={14}/>}
            Originated by: {notification.userName}
        </div>}
    </>;
});

export default PolicyNotification;
